import { CommonSearchParam, ApiBind } from './common-search-param.model';

export class DeviceModelGroupSearchParam extends CommonSearchParam {

  constructor(
    name?: string,
  ) {
    super();
    this.name = name;
  }

  @ApiBind({ column: 'name' })
  name: string;
}
